import React from 'react';

interface NavigationArrowIconProps {
  direction: 'left' | 'right';
  isActive?: boolean;
  size?: number;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const NavigationArrowIcon: React.FC<NavigationArrowIconProps> = ({
  direction,
  isActive = true,
  size = 56,
  className = '',
  onClick,
  disabled = false
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  if (direction === 'left') {
    return (
      <button
        className={`navigation-arrow navigation-arrow-left ${!isActive ? 'inactive' : ''} ${className}`}
        onClick={handleClick}
        disabled={disabled || !isActive}
        aria-label="Previous"
        style={{
          background: 'transparent',
          border: 'none',
          cursor: isActive ? 'pointer' : 'default',
          padding: 0
        }}
      >
        {!isActive ? (
          <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="#D5D8DB" fillOpacity="0.4"/>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7071 17.2929C32.3166 16.9024 31.6834 16.9024 31.2929 17.2929L21.2929 27.2929C20.9024 27.6834 20.9024 28.3166 21.2929 28.7071L31.2929 38.7071C31.6834 39.0976 32.3166 39.0976 32.7071 38.7071C33.0976 38.3166 33.0976 37.6834 32.7071 37.2929L23.4142 28L32.7071 18.7071C33.0976 18.3166 33.0976 17.6834 32.7071 17.2929Z"
              fill="#D5D8DB"
              fillOpacity="0.4"
            />
          </svg>
        ) : (
          <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="white"/>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7071 17.2929C32.3166 16.9024 31.6834 16.9024 31.2929 17.2929L21.2929 27.2929C20.9024 27.6834 20.9024 28.3166 21.2929 28.7071L31.2929 38.7071C31.6834 39.0976 32.3166 39.0976 32.7071 38.7071C33.0976 38.3166 33.0976 37.6834 32.7071 37.2929L23.4142 28L32.7071 18.7071C33.0976 18.3166 33.0976 17.6834 32.7071 17.2929Z"
              fill="#222325"
            />
          </svg>
        )}
      </button>
    );
  }

  // Right arrow
  return (
    <button
      className={`navigation-arrow navigation-arrow-right ${!isActive ? 'inactive' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled || !isActive}
      aria-label="Next"
      style={{
        background: 'transparent',
        border: 'none',
        cursor: isActive ? 'pointer' : 'default',
        padding: 0
      }}
    >
      {!isActive ? (
        <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="56" height="56" rx="28" fill="#D5D8DB" fillOpacity="0.4"/>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.2929 17.2929C23.6834 16.9024 24.3166 16.9024 24.7071 17.2929L34.7071 27.2929C35.0976 27.6834 35.0976 28.3166 34.7071 28.7071L24.7071 38.7071C24.3166 39.0976 23.6834 39.0976 23.2929 38.7071C22.9024 38.3166 22.9024 37.6834 23.2929 37.2929L32.5858 28L23.2929 18.7071C22.9024 18.3166 22.9024 17.6834 23.2929 17.2929Z"
            fill="#D5D8DB"
            fillOpacity="0.4"
          />
        </svg>
      ) : (
        <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="56" height="56" rx="28" fill="white"/>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.2929 17.2929C23.6834 16.9024 24.3166 16.9024 24.7071 17.2929L34.7071 27.2929C35.0976 27.6834 35.0976 28.3166 34.7071 28.7071L24.7071 38.7071C24.3166 39.0976 23.6834 39.0976 23.2929 38.7071C22.9024 38.3166 22.9024 37.6834 23.2929 37.2929L32.5858 28L23.2929 18.7071C22.9024 18.3166 22.9024 17.6834 23.2929 17.2929Z"
            fill="#222325"
          />
        </svg>
      )}
    </button>
  );
};

export default NavigationArrowIcon;